import { Button, Form, Input, message, Modal } from "antd";

import { DownOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import "../Styles/UpdateAllProduct.css";
import { useEffect, useState } from "react";
import axios from "axios";
import TextArea from "antd/es/input/TextArea";
import { IconButton } from "@mui/material";

// import { IconButton } from "@mui/material";
const UpdateVendor = ({ store }) => {
  // eslint-disable-next-line no-unused-vars
  const { id } = useParams();
  const product = Array.isArray(store)
    ? store.find((item) => item.id === parseInt(id))
    : null;
  const [Logo, setLogo] = useState(null);

  const [form] = Form.useForm();
  //todo this is get API for User
  useEffect(() => {
    if (product) {
      const LogoImage = product.logo ? `${product.logo}` : null;
      // console.log("LogoImage", LogoImage);
      setLogo(LogoImage);
      const nameObj = JSON.parse(product.name);
      const descriptionObj = JSON.parse(product.address);
      form.setFieldsValue({
        TitleKurdish: nameObj.ku || "", // Access nameObj.ku directly
        TitleArabic: nameObj.ar || "", // Access nameObj.ar directly
        number: product.number || "",
        DescriptionKurdish: descriptionObj.ku || "", // Access descriptionObj.ku directly
        DescriptionArabic: descriptionObj.ar || "", // Access descriptionObj.ar directly
      });
    }
  }, [product, form]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const handleImageChange = async (file) => {
    // Generate a preview URL for the image file
    const previewUrl = URL.createObjectURL(file);
    setImagePreviewUrl(previewUrl);
    // Proceed with the upload logic
    const formData = new FormData();
    formData.append("file", file);
    // console.log("file", file);
    const response = await axios.post(
      "https://bardawamplus.com/api/upload-file",
      formData
    );
    if (response.status === 200) {
      const LogoImage = response.data.path;
      setLogo(LogoImage);
      message.success("Image uploaded successfully");
      // Revoke the preview URL after upload is successful
      URL.revokeObjectURL(previewUrl);
    } else {
      message.error("Failed to upload image");
    }
  };
  const normFile = (e) => {
    return e && e.fileList ? [e.file] : [];
  };
  const onChangeUpload = async (e) => {
    if (e && e.target && e.target.files) {
      const file = e.target.files[0];
      await handleImageChange(file);
    }
  };

  //todo update user
  //todo this is Modal  Name
  const [isModalOpenNew, setIsModalOpenNew] = useState(false);
  // const [form] = Form.useForm(); // Form instance for the outer form
  const handleCancelNew = () => {
    setIsModalOpenNew(false);
  };
  const showModalNew = () => {
    setIsModalOpenNew(true);
  };

  const handleOkNew = () => {
    setIsModalOpenNew(false);
  };
  //! End modal
  //todo this is Modal  Description
  const [isModalOpenNew2, setIsModalOpenNew2] = useState(false);
  // const [form] = Form.useForm(); // Form instance for the outer form
  const handleCancelNew2 = () => {
    setIsModalOpenNew2(false);
  };
  const showModalNew2 = () => {
    setIsModalOpenNew2(true);
  };

  const handleOkNew2 = () => {
    setIsModalOpenNew2(false);
  };
  //! End modal
  const onFinish = async (values) => {
    try {
      values["logo"] = Logo;
      const name = {
        ar: form.getFieldValue("TitleArabic"),
        ku: form.getFieldValue("TitleKurdish"),
      };
      const address = {
        ar: form.getFieldValue("DescriptionArabic"),
        ku: form.getFieldValue("DescriptionKurdish"),
      };

      const updatedValues = {
        ...values,
        number: values.number, // Keeping number as is
        name: name,
        address: address,
      };

      // Route::put('/stores/{id}/pstbdp', [StoreController::class, 'update']);

      const response = await axios.put(
        // `https://bardawamplus.com/api/stores/${id}`,
        `https://bardawamplus.com/api/stores/${id}/pstbdp`,
        updatedValues
      );

      if (response.status >= 200 && response.status < 300) {
        message.success("Successfully updated");
        window.location.href = "/AllVendor";
      } else {
        message.error(`Unexpected response status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error during update:", error); // Detailed error logging
      message.error("Failed to update. Please try again.");
    }
  };

  const onFinishFailed = () => {
    // console.log("Failed:", errorInfo);
    message.error("Error");
  };
  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 16,
    },
  };
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>update Vendor</h1>

      {/* //! end image ================================= */}
      <Form
        form={form}
        {...layout}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        {/* //todo this is image  */}
        <div className="centered-form-item">
          <Form.Item
            name="Logo"
            // label="Logo"
            valuePropName="fileList"
            getValueFromEvent={normFile}
          >
            <input
              id="single-image-upload"
              type="file"
              style={{ display: "none" }}
              onChange={onChangeUpload}
            />
            <label htmlFor="single-image-upload" style={{ width: "30%" }}>
              <IconButton
                style={{ width: "100%", padding: "10px" }}
                color="primary"
                aria-label="upload picture"
                component="span"
                className="upload-button"
              >
                Image
              </IconButton>
            </label>

            {imagePreviewUrl ? (
              <img
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                src={imagePreviewUrl}
                alt="Preview of the selected file"
                className="image-preview"
              />
            ) : Logo ? (
              <img
                src={`https://bardawamplus.com/api/storage/${Logo}`}
                alt="Uploaded file preview"
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                className="image-preview"
              />
            ) : null}
          </Form.Item>
        </div>

        {/* //todo this is name  */}
        <div className="NameAdders">
          <Form.Item name="name">
            <Button type="text" className="ButtonName" onClick={showModalNew}>
              <div className="OnButton">
                Name
                <DownOutlined />
              </div>
            </Button>

            <Modal
              title="Name"
              open={isModalOpenNew}
              onOk={handleOkNew}
              onCancel={handleCancelNew}
              footer={
                <div>
                  <Button
                    type="primary"
                    onClick={handleOkNew}
                    style={{
                      width: "30%",
                    }}
                  >
                    save
                  </Button>
                  <span> </span>
                  <Button onClick={handleCancelNew}>cancel</Button>
                </div>
              }
            >
              <Form
                form={form}
                onFinishFailed={onFinishFailed}
                initialValues={{ remember: true }}
              >
                <Form.Item name="TitleKurdish" label="Kurdish">
                  <Input placeholder="Type your Title Kurdish" />
                </Form.Item>
                <Form.Item name="TitleArabic" label="Arabic">
                  <Input placeholder="Type your Title Arabic" />
                </Form.Item>
              </Form>
            </Modal>
          </Form.Item>
        </div>
        {/* //todo ----------------------------------------------- */}

        <Form.Item name="number" label="number">
          <Input
            style={{ width: "40%", paddingLeft: 20 }}
            placeholder="Type your number"
          />
        </Form.Item>

        {/* //todo this is description */}
        <div className="NameAdders">
          <Form.Item name="name">
            <Button type="text" className="ButtonName" onClick={showModalNew2}>
              <div className="OnButton">
                Description
                <DownOutlined />
              </div>
            </Button>

            <Modal
              title="Description"
              open={isModalOpenNew2}
              onOk={handleOkNew2}
              onCancel={handleCancelNew2}
              footer={
                <div>
                  <Button
                    type="primary"
                    onClick={handleOkNew2}
                    style={{
                      width: "30%",
                    }}
                  >
                    save
                  </Button>
                  <span> </span>
                  <Button onClick={handleCancelNew2}>cancel</Button>
                </div>
              }
            >
              <Form
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{ remember: true }}
              >
                <Form.Item
                  name="DescriptionKurdish"
                  label="Description Kurdish"
                >
                  <TextArea
                    showCount
                    maxLength={250}
                    style={{
                      height: 65,
                      resize: "none",
                    }}
                    placeholder="Type your Title Kurdish"
                  />
                </Form.Item>
                <Form.Item name="DescriptionArabic" label="Description Arabic">
                  <TextArea
                    showCount
                    maxLength={250}
                    // onChange={onChange}
                    style={{
                      height: 65,
                      resize: "none",
                    }}
                    placeholder="Type your Title Arabic"
                  />
                </Form.Item>
              </Form>
            </Modal>
          </Form.Item>
        </div>

        {/* //! ----------------------------------------------- */}

        <Form.Item label=".">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <span style={{ margin: "0 8px" }}></span>
        </Form.Item>
      </Form>
    </div>
  );
};

export default UpdateVendor;
